import { Button, Card, H1 } from '@payaca/ambrosia';
import { FunctionComponent, type JSX } from 'react';
import { useIntercom } from 'react-use-intercom';

import AuthenticatedPageWrapper from '@/ui/layouts/authenticatedPageWrapper/AuthenticatedPageWrapper';

import { useCreateBillingPortalSession } from '@/api/mutations/subscriptions/useCreateBillingPortalSession';

const ManageSubscriptionPage: FunctionComponent = (): JSX.Element => {
  const { show } = useIntercom();

  const billingPortalMutation = useCreateBillingPortalSession({
    onSuccess: (data) => {
      if (
        data.createBillingPortalSession.__typename ===
        'CreateBillingPortalSessionSuccess'
      ) {
        window.location.href = data.createBillingPortalSession.url;
      }
    },
  });

  let error: string | null = null;
  if (
    billingPortalMutation.data?.createBillingPortalSession.__typename ===
    'CreateBillingPortalSessionError'
  ) {
    error = billingPortalMutation.data.createBillingPortalSession.message;
  } else if (billingPortalMutation.error) {
    error = 'Unable to open subscription portal. Please try again.';
  }

  const handleManageSubscription = () => {
    billingPortalMutation.mutate();
  };

  return (
    <AuthenticatedPageWrapper>
      <div className="px-8 py-4">
        <H1>Manage subscription</H1>
      </div>
      <div className="p-4 pt-0">
        <Card sizeVariant="lg">
          <Card.Body>
            <div className="flex flex-col items-center gap-y-4 py-8">
              <p className="text-gray-600 text-center max-w-xl">
                Manage your subscription, update payment methods, view invoices,
                and more through our billing portal.
              </p>
              {error && <p className="text-red-600 text-sm">{error}</p>}
              <Button
                onClick={handleManageSubscription}
                isProcessing={billingPortalMutation.isPending}
              >
                Open billing portal
              </Button>
            </div>
            <div className="flex items-center justify-center gap-x-3 mt-6 border-t pt-6">
              <span className="text-gray-500">Need help?</span>
              <Button variant="secondary" size={'sm'} onClick={show}>
                Get in touch
              </Button>
            </div>
          </Card.Body>
        </Card>
      </div>
    </AuthenticatedPageWrapper>
  );
};

export default ManageSubscriptionPage;
